import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { getUserPremiumStatus } from 'owa-user-premium-status-store';
import { RegisterForAccountStateChange } from 'owa-account-source-list';
import { type AccountSource } from 'owa-account-source-list-store';
import { areAnyAccountsEnterpriseOrPremiumConsumer } from './utils/areAnyAccountsEnterpriseOrPremiumConsumer';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

let checked = false;
let enabled = false;

/**
 * This capability is used to determine if mail template capabilities should be supported.
 *
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 */
export const mailTemplatesCapability: Capability = {
    // If the user is eligible for the feature
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        if (isGlobalFeatureEnabled('acct-templates-quickparts-premiumStatus')) {
            return getUserPremiumStatus();
        } else {
            if (checked) {
                return enabled;
            }

            enabled = areAnyAccountsEnterpriseOrPremiumConsumer();
            checked = true;

            RegisterForAccountStateChange(onAccountsChanged, onAccountsChanged);

            return enabled;
        }
    },

    // If the feature has rolled out to the user by account
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return true;
    },
};

// Callback for when an account is added or removed
const onAccountsChanged = async (_accountSource: AccountSource) => {
    enabled = areAnyAccountsEnterpriseOrPremiumConsumer();
};
